import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { WindowToken } from '@app/shared/window.token';
import { ReportScheduleGuard } from './report-schedule.guard';
import { ReportingInAppGuard } from './reporting-in-app.guard';
import { ReportingBaseGuard } from './reporting-base.guard';

@Injectable({
  providedIn: 'root',
})
export class ReportingRedirectGuard
  extends ReportingBaseGuard
  implements CanActivate {
  constructor(
    authService: AuthService,
    @Inject(WindowToken) windowRef: Window,
    private reportingInAppGuard: ReportingInAppGuard,
    private reportScheduleGuard: ReportScheduleGuard,
    router: Router
  ) {
    super(authService, windowRef, router);
    this._hasPermission =
      this.reportingInAppGuard.hasPermission ||
      this.reportScheduleGuard.hasPermission;
    this.routeDirectory = '/reporting';
  }
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): UrlTree {
    if (this.reportingInAppGuard.hasPermission) {
      return this.router.parseUrl(this.resolveOrgUrl('/downloads'));
    }
    if (this.reportScheduleGuard.hasPermission) {
      return this.router.parseUrl(this.resolveOrgUrl('/reportSchedule'));
    }
    return this.router.parseUrl('/');
  }
}
